export const PARTNER_DETAILS = "PARTNER_DETAILS";
export const PARTNER_CONFIG = "PARTNER_CONFIG";

const initialState = {
  partnerDetail: null,
  partnerConfig: null,
};

const DomainReducer = (state = initialState, action) => {
  switch (action.type) {
    case PARTNER_DETAILS:
      return {
        ...state,
        partnerDetail: action.payload,
      };
    case PARTNER_CONFIG:
      return {
        ...state,
        partnerConfig: action.payload,
      };
    default:
      return state;
  }
};

export default DomainReducer;

export const setDomainData = (data) => ({
  type: PARTNER_DETAILS,
  payload: data,
});

export const setPartnerConfig = (data) => ({
  type: PARTNER_CONFIG,
  payload: data,
});
